import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchTeams } from '@/api/v4/team.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { prepareTeamApiFilters } from './filters/teams-filters-helpers';
import { appliedTeamsFiltersState, teamsSortState } from './team.state';
import { useAtomValue } from 'jotai';

export const useTeams = () => {
  const { hasRequiredPermission } = useUserPermissions();
  const appliedFilters = useAtomValue(appliedTeamsFiltersState);
  const { sort, direction } = useAtomValue(teamsSortState);
  const filters = prepareTeamApiFilters(appliedFilters);

  return useInfiniteQuery({
    queryKey: [QueryKey.Teams, sort, direction, filters],
    queryFn: ({ pageParam = 1 }) => {
      const params = {
        sort,
        direction,
        page: pageParam,
        items: 20,
        ...filters,
      };
      return fetchTeams(params);
    },
    initialPageParam: 1,
    enabled:
      hasRequiredPermission(PERMISSION.VIEW_ACCOUNT_DETAILS) ||
      hasRequiredPermission(PERMISSION.MANAGE_TEAMS),
    staleTime: 1000 * 10 * 5,
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
  });
};
